import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Label,
  ModalHeader,
  Tooltip,
  Row,
  CardImg,
} from 'reactstrap';
import ImageGallery from '../../../propinfo/gallery/index';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
let arr = [];
export default function EmailSignature({
  integration,
  integrationProperties,
  allProperties,
  channelDetails,
  saveIntegration,
}) {
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [signatureSetting, setSignatureSetting] = useState(
    channelDetails?.emailSignature || {
      enabled: false,
      position: '',
      customText: '',
      logoWidth: 10,
      logoHeight: 10,
      allContext: false,
    }
  );
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const handleSave = () => {
    channelDetails.emailSignature = signatureSetting;
    saveIntegration({ channelDetails });
  };

  const handleEmailSignatureEnabled = (e) =>
    setSignatureSetting({ ...signatureSetting, enabled: e });

  const handleSignatureChange = (e) =>
    setSignatureSetting({
      ...signatureSetting,
      [e.target.name]: e.target.value,
    });

  const handleSignaturePosition = (e) =>
    setSignatureSetting({ ...signatureSetting, position: e });

  const selectedImage = (image) => {
    setSignatureSetting({
      ...signatureSetting,
      logo: image.src,
    });
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Email Signature</h6>
          </div>
          <Separator className="mb-3" />
          <Row className="ml-2 my-3">
            <Colxx md="12" className="mb-3">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small  float-left"
                checked={signatureSetting?.enabled}
                name="enabled"
                onChange={(e) => handleEmailSignatureEnabled(e)}
              />
            </Colxx>
          </Row>

          <Colxx md="12">
            <div className=" ml-2 my-2 mb-3">
              <Row className="">
                <Colxx md="6" className="align-self-center">
                  <h5>Logo</h5>
                  <span style={{ color: 'rgb(100 98 98)' }}>Upload a PNG, JPG, or GIF image smaller than 1MB.</span>
                </Colxx>
                <Colxx md="6" className="text-right">
                  <CardImg
                    top
                    src={signatureSetting?.logo}
                    alt="logo"
                    className="img-thumbnail border-0 rounded-circle list-thumbnail"
                  />
                  <div className="mb-1">
                    <Button
                      color="success"
                      size="xs"
                      className="mt-1"
                      onClick={togglegallery}
                    >
                      Browse Avatars
                    </Button>
                  </div>
                </Colxx>
              </Row>
            </div>


            <div className="ml-2 mb-3">
              <Row>
                <Colxx md="6" className="align-self-center">
                  <h5>Position</h5>
                  <span style={{ color: 'rgb(100 98 98)' }}>Control where your logo will be displayed alongside your text.</span>
                </Colxx>
                <Colxx md="6" className="text-right align-self-center ">
                  <span
                    className="ml-3"
                    onClick={() => handleSignaturePosition('Left')}
                  >
                    <i
                      style={{
                        color: `${signatureSetting?.position === 'Left'
                          ? 'var(--theme-color-1)'
                          : 'rgb(160 159 159)'
                          }`,
                        fontSize: '30px',
                      }}
                      className="simple-icon-arrow-left-circle"
                    />
                    {/* <svg
                      style={{
                        borderColor: `${signatureSetting?.position === 'Left'
                          ? 'var(--theme-color-1)'
                          : 'black'
                          }`,
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokewidth="1.5"
                      className="signature-position"
                      stroke="currentColor"
                    >
                      <path
                        strokelinecap="round"
                        strokelinejoin="round"
                        d="M7.49 12 3.74 8.248m0 0 3.75-3.75m-3.75 3.75h16.5V19.5"
                      />
                    </svg> */}
                  </span>
                  <span
                    className="ml-2"
                    onClick={() => handleSignaturePosition('Right')}
                  >

                    <i
                      style={{
                        color: `${signatureSetting?.position === 'Right'
                          ? 'var(--theme-color-1)'
                          : 'rgb(160 159 159)'
                          }`,
                        fontSize: '30px',
                      }}
                      className="simple-icon-arrow-right-circle"
                    />
                  </span>
                  <span
                    className="ml-2"
                    onClick={() => handleSignaturePosition('Up')}
                  >
                    <i
                      style={{
                        color: `${signatureSetting?.position === 'Up'
                          ? 'var(--theme-color-1)'
                          : 'rgb(160 159 159)'
                          }`,
                        fontSize: '30px',
                      }}
                      className="simple-icon-arrow-up-circle"
                    />
                  </span>
                  <span
                    className="ml-2"
                    onClick={() => handleSignaturePosition('Down')}
                  >
                    {/* <svg
                      style={{
                        borderColor: `${signatureSetting?.position === 'Down'
                          ? 'var(--theme-color-1)'
                          : 'rgb(160 159 159)'
                          }`,
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokewidth="1.5"
                      className="signature-position"
                      stroke="currentColor"
                    >
                      <path
                        strokelinecap="round"
                        strokelinejoin="round"
                        d="m11.99 16.5 3.75 3.75m0 0 3.75-3.75m-3.75 3.75V3.75H4.49"
                      />
                    </svg> */}
                    <i
                      style={{
                        color: `${signatureSetting?.position === 'Down'
                          ? 'var(--theme-color-1)'
                          : 'rgb(160 159 159)'
                          }`,
                        fontSize: '30px',
                      }}
                      className="simple-icon-arrow-down-circle"
                    />
                  </span>
                  {/* <Input
                    className="form-control"
                    type="select"
                    defaultValue={signatureSetting?.position}
                    name="position"
                    onChange={handleSignatureChange}
                  >
                    <option value={'Left'}>Left</option>
                    <option value={'Top'}>Top</option>
                    <option value={'Right'}>Reight</option>
                    <option value={'Bottom'}>Bottom</option>
                  </Input> */}
                </Colxx>
              </Row>
            </div>

            <div className="ml-2 mb-3 mt-2">
              <Row>
                <Colxx md="6" className="align-self-center">
                  <h5>Size</h5>
                  <span style={{ color: 'rgb(100 98 98)' }}>Control the size of your logo.</span>
                </Colxx>
                <Colxx md="6" className="text-left">
                  <Row>
                    {' '}
                    <Colxx md="6" className="px-2d">
                      <FormGroup row>
                        <Label sm="12">Width</Label>
                        <Colxx sm="12" className="d-flex align-items-center">
                          <Input
                            className="form-control"
                            type="number"
                            style={{ width: '60%' }}
                            defaultValue={signatureSetting?.logoWidth}
                            name="logoWidth"
                            onChange={handleSignatureChange}
                          />
                          <span className="px-box" >px</span>
                        </Colxx>
                      </FormGroup>
                    </Colxx>
                    <Colxx md="6">
                      <FormGroup row>
                        <Label sm="12">Height</Label>
                        <Colxx sm="12" className="d-flex align-items-center">
                          <Input
                            className="form-control ml-2"
                            type="number"
                            style={{ width: '60%' }}
                            defaultValue={signatureSetting?.logoHeight}
                            name="logoHeight"
                            onChange={handleSignatureChange}
                          ></Input>
                          <span className="px-box" >px</span>
                        </Colxx>
                      </FormGroup>
                    </Colxx>
                  </Row>
                </Colxx>
              </Row>
            </div>
            <Separator className="my-2"></Separator>
            <div className="ml-2 mb-3">
              <Label className="mb-2">
                <h5>Custom Text</h5>
              </Label>
              <Input
                className="form-control"
                type="textarea"
                style={{ height: '50px' }}
                placeholder="Custom Text"
                defaultValue={signatureSetting?.customText}
                name="customText"
                onChange={handleSignatureChange}
              ></Input>
            </div>
          </Colxx>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"

            >
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
      {ImageGalleryButton()}
    </Fragment>
  );
}
